export { default as Img200 } from './processed/200/Trust-S1.jpg';
export { default as Img400 } from './processed/400/Trust-S1.jpg';
export { default as Imgthumb } from './processed/thumb/Trust-S1.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Trust-S1.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Trust-S1.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      50,
      96,
      119
    ],
    "_population": 306,
    "_hsl": [
      0.5555555555555556,
      0.40828402366863914,
      0.33137254901960783
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      30,
      82,
      108
    ],
    "_population": 426,
    "_hsl": [
      0.5555555555555555,
      0.5652173913043479,
      0.27058823529411763
    ]
  },
  "Muted": {
    "_rgb": [
      88,
      129,
      162
    ],
    "_population": 68,
    "_hsl": [
      0.5743243243243243,
      0.296,
      0.49019607843137253
    ]
  },
  "LightMuted": {
    "_rgb": [
      182,
      182,
      161
    ],
    "_population": 2366,
    "_hsl": [
      0.16666666666666666,
      0.12574850299401205,
      0.6725490196078432
    ]
  },
  "DarkMuted": {
    "_rgb": [
      48,
      66,
      75
    ],
    "_population": 2760,
    "_hsl": [
      0.5555555555555555,
      0.21951219512195125,
      0.2411764705882353
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Trust-S1.js